import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import "dayjs/locale/en-gb";
import "dayjs/locale/sq";

dayjs.extend(localizedFormat);

export const setDayjsLocale = (locale: string) => {
  dayjs.locale(locale);
};
